import { UserProfileApi } from 'api';
import { apiCallStatus, } from 'helpers/constants';
import * as actionTypes from './constants';
import {
    setPersistentUserInfo,
    mergeUserInfo
} from './helpers';
import { getApiActionCreator } from 'helpers/actionHelper';
import * as actions from '../PowertrainOverview/actions';

const loadUserInfoAction = getApiActionCreator(actionTypes.LOAD_USER);


export const loadUserInfo = (userCredentials, setTokensRetrieved, errorHandler) => {
    return (dispatch) => {
        dispatch(loadUserInfoAction(apiCallStatus.LOADING));
        Promise.all([
            UserProfileApi.getUserProfile(),
        ])
            .then(([userInfoMicroService]) => {

                // Call broadcast messages API if broadcast info exists
                if (userInfoMicroService?.broadcastMessages &&
                    userInfoMicroService.broadcastMessages.length > 0 &&
                    !userInfoMicroService.broadcastMessages[0]?.isDeleted) {

                    dispatch(actions.loadBroadcastMessages(userInfoMicroService.broadcastMessages[0].broadcastMessageID));
                }

                setPersistentUserInfo(userInfoMicroService);
                dispatch(loadUserInfoAction(apiCallStatus.SUCCESS, mergeUserInfo(userInfoMicroService)));
                setTokensRetrieved(true);
            }).catch((error) => {
                dispatch(loadUserInfoAction(apiCallStatus.ERROR, null, error));
                errorHandler();
            });
    };
};
